import { render, staticRenderFns } from "./CaseLinks.vue?vue&type=template&id=d592d5f0&"
import script from "./CaseLinks.vue?vue&type=script&lang=ts&"
export * from "./CaseLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports